import React from 'react';
import Tooltip from '../../../../../component/tooltip';
import { LabelInterface } from '../../../../../interfaces/TaskInterface';
import { LABEL_COLOUR_HASH } from '../../../../../global/constants';
import { MultipleLabel, DropBlock, DotIcon, DropLabel, MainTooltipDiv, TooltipDiv } from '../../styles';

interface Props {
  labelData?: LabelInterface[] | null;
  labelsVisible: boolean;
  maxVisibleLabels: number;
  taskLabels?: LabelInterface[] | null;
}

const TaskLabelList = React.memo(function TaskLabelList({
  labelData,
  labelsVisible,
  maxVisibleLabels,
  taskLabels
}: Props) {
  if (!labelData || !labelsVisible || labelData.length === 0) return null;

  return (
    <MultipleLabel>
      {labelData.map((label, index) => {
        if (index < maxVisibleLabels) {
          return (
            <DropBlock key={label?.id} className={index === 0 ? 'left-border' : ''}>
              <DotIcon color={LABEL_COLOUR_HASH[label?.color]} />
              <DropLabel>{label?.name}</DropLabel>
            </DropBlock>
          );
        } else if (index === maxVisibleLabels) {
          const remainingLabels = (taskLabels?.length || 0) - maxVisibleLabels;
          if (remainingLabels > 0) {
            const tooltipContent = (
              <MainTooltipDiv>
                {taskLabels?.slice(maxVisibleLabels).map((l) => (
                  <TooltipDiv key={l.id}>
                    <DotIcon color={LABEL_COLOUR_HASH[l.color]} />
                    <span>{l.name}</span>
                  </TooltipDiv>
                ))}
              </MainTooltipDiv>
            );
            return (
              <Tooltip title={tooltipContent} maxWidth={'max-content'} key={`more-${label?.id}`}>
                <DropBlock>
                  <DropLabel>+{remainingLabels} more</DropLabel>
                </DropBlock>
              </Tooltip>
            );
          }
        }
        return null;
      })}
    </MultipleLabel>
  );
});

export default TaskLabelList;
